module.exports = __webpack_public_path__ + "assets/img/join2021_011.df2c8835.png";